<!-- class="comments-input-block-overlay" -->
<div class="comments-input-block-overlay" (click)="closeComments()"></div>
<img class="comments-logo unselectable" alt="facebook logo"/>
<div class="comments-header unselectable">
  <div class="comments-header-text">{{ 'COMMENTS' | translate | uppercase}}</div>
</div>
<div class="close-button" [class.show-close-button]="commentsVisible" (click)="closeComments()"></div>
<div class="comments-content">
  <div class="comments-content-container">
    <div id="fb-root"></div>
    <div class="fb-comments" data-href="https://logos.bg/" data-width="100%" data-numposts="5"></div>
  </div>
</div>
